import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

import UsersApi from "../../Classes/API/UsersApi";
import AccountingApi from "../../Classes/API/AccountingApi";
import TextField from "@mui/material/TextField";
import CardHeader from "@mui/material/CardHeader";
import SessionsApi from "../../Classes/API/Administration/SessionsApi";
import CreateAccountingEntryReq from "../../Classes/Models/Requests/Accounting/CreateAccountingEntryReq";
import SearchUserModel from "../../Classes/Models/Requests/Users/SearchUser";
import SearchAccountingSessions from "../../Classes/Models/Requests/Accounting/SearchAccountingSession";
import SearchAccountingTherapistHourId from "../../Classes/Models/Requests/Accounting/SearchAccountingTherapistHourId";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import SearchPackagesReq from "../../Classes/Models/Requests/AccountingSessions/CreatePackageReq";

import { useLocation } from "react-router-dom";

import AsyncSelect from "react-select/async";
import TestCreate from "../../Classes/Models/Requests/Accounting/TestCreate";
import { useContext } from "react";
import { UserContext } from "App";
import { Title } from "chart.js";
import RefundReq from "../../Classes/Models/Requests/Accounting/RefundReq";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { LanguageContext } from "App";
import { use } from "react";

const EXPENSE_CATEGORIES = [
  "بوفيه",
  "كهربا-مياه - غاز-انترنت",
  "ادوات مكتبية",
  "عهد",
  "مستلزمات مخزن",
  "مرسال",
  "مسحوبات",
  "الاقامات",
  "اصول",
  "اجور + مكافأت",
  "صيانة",
  "سلف عاملين",
  "رد",
  "تشغيل",
  "نظافة",
];

const EntryTypes = {
  AccSession: "AccountingSession",
  Package: "Package",
  AccThHour: "AccountingTherapistHour",
  BalanceEntry: "UserBalance",
  Salary: "Salary",
  Expense: "Expense",
};

const CreateAccountingEntry = () => {
  const CurrentUser = useContext(UserContext);

  // const EntryTypes = {
  //   AccSession: "Accounting Session",
  //   Package: "Package",
  //   AccThHour: "Accounting Therapist Hour",
  //   UserBalance: "User Balance",
  //   Salary: "Salary",
  //   Expense: "Expense",
  // };

  const [UsersSearch, SetUsersSearch] = useState("");
  const [TherapistsSearch, SetTherapistSearch] = useState("");
  const [AccountingTherapistHourSearch, SetAccountingTherapistHourSearch] = useState("");
  const [AccountingSessionsSearch, SetAccouningSessionsSearch] = useState("");
  const [PackagesSearch, SetPackagesSearch] = useState("");
  const { translations } = useContext(LanguageContext);
  const [title, SetTitle] = useState("");
  const [amount, SetAmount] = useState(0);
  const [description, SetDescription] = useState("");
  const [category, SetCategory] = useState("");
  const [entryType, SetEntryType] = useState("");
  const [User, SetUser] = useState();
  const [accountingSession, SetaccountingSession] = useState();
  const [therapistId, SettherapistId] = useState();
  const [beneficiaryEntity, setBeneficiaryEntity] = useState("");
  const [Package, SetPackage] = useState();
  const [accountingTherapistHourId, SetaccountingTherapistHourId] = useState();
  const [paymentMethod, setPaymentMethod] = useState("");

  const [UserSelectDefault, SetUserSelectDefault] = useState("None");
  const [PackageSelectDefault, SetPackageSelectDefault] = useState("None");
  const [AccountingSessionSelectDefault, SetAccountingSessionSelectDefault] = useState("None");
  const [AccountingThHourSelectDefault, SetAccountingThHourSelectDefault] = useState("None");

  const [IsLoaded, setIsLoaded] = useState(false);

  const [OptionUser, SetOptionUser] = useState([]);
  const [OptionPackage, SetOptionPackage] = useState([]);
  const [OptionSession, SetOptionSession] = useState([]);
  const [OptionTherapis, SetOptionTherapis] = useState([]);

  useEffect(() => {
    GetAccountingTherapistHours().then((res) => SetOptionTherapis(res));
  }, []);

  useEffect(() => {
    GetAccountingSessions().then((res) => SetOptionSession(res));
  }, []);

  useEffect(() => {
    GetPackages().then((res) => SetOptionPackage(res));
  }, []);

  useEffect(() => {
    GetUsers().then((res) => SetOptionUser(res));
  }, []);

  const { state } = useLocation();
  const CheckState = () => {
    if (!state) {
      SetEntryType(EntryTypes.Expense);
      setIsLoaded(true);
      return;
    } else {
      switch (state.entryType) {
        case EntryTypes.AccSession:
          SetEntryType(state.entryType);

          SetTitle("Auto Generated Acc.Session Entry");

          SetDescription(
            "Acc.Session Id: " +
              state.AccSession.id +
              ",     Patient Name: " +
              state.AccSession.getPatient.getUser.name +
              ",     Patient Id: " +
              state.AccSession.patientId +
              ",     User Id: " +
              state.AccSession.getPatient.getUser.id +
              ",     Original Price: EGP" +
              state.AccSession.originalPrice +
              ",     Discount %: " +
              state.AccSession.discount +
              ",     Final Price: EGP" +
              state.AccSession.finalPrice +
              ",     This entry was created by --> Id: " +
              CurrentUser.id +
              ",    Name: " +
              CurrentUser.name
          );

          SetCategory("Accounting Sessions");

          SetaccountingSession(state.AccSession);
          SetAccountingSessionSelectDefault(
            "Accounting Session Id: " +
              state.AccSession.id +
              "     Patient Id: " +
              state.AccSession.patientId
          );
          SetAmount(state.AccSession.finalPrice);
          break;

        case EntryTypes.Package:
          SetEntryType(state.entryType);

          SetTitle("Auto Generated Package Entry");

          SetDescription(
            "Acc.Session Id: " +
              state.Package.id +
              ",     Patient Name: " +
              state.Package.getPatient.getUser.name +
              ",     Patient Id: " +
              state.Package.patientId +
              ",     User Id: " +
              state.Package.getPatient.getUser.id +
              ",     Original Price: EGP" +
              state.Package.originalPrice +
              ",     Discount %: " +
              state.Package.discount +
              ",     Final Price: EGP" +
              state.Package.finalPrice +
              ",     Created By: " +
              CurrentUser.id +
              "    ,Name: " +
              CurrentUser.name
          );
          SetCategory("Packages");

          SetPackage(state.Package);
          SetPackageSelectDefault(
            "Package Id: " + state.Package.id + "     Patient Id: " + state.Package.patientId
          );
          SetAmount(state.Package.finalPrice);

          break;

        case EntryTypes.UserBalance:
          SetEntryType(state.entryType);

          SetUserSelectDefault(state.User.id);
          break;

        case EntryTypes.AccThHour:
          SetEntryType(state.entryType);
          SetTitle("Auto Generated AccThHour Entry");

          SetDescription(
            "AccThHourId: " +
              state.AccThHour.id +
              ",     Therapist Name: " +
              state.AccThHour.getTherapist.getUser.name +
              ",     TherapistId: " +
              state.AccThHour.therapistId +
              ",     UserId: " +
              state.AccThHour.getTherapist.getUser.id +
              ",     PricePerHour: EGP" +
              state.AccThHour.pricePerHour +
              ",     Final Price: EGP" +
              state.AccThHour.finalPrice +
              ",      AccSessionId: " +
              state.AccThHour.accountingSessionId +
              ",     Created By: " +
              CurrentUser.id +
              "    ,Name: " +
              CurrentUser.name
          );

          SetaccountingTherapistHourId(state.AccThHour.id);
          SetCategory("Accounting Therapist Hours");
          SetAccountingThHourSelectDefault("Accounting Therapist Hour Id: " + state.AccThHour.id);
          SetAmount(state.AccThHour.finalPrice);
          break;

        default:
          break;
      }
    }
    setIsLoaded(true);
  };

  useEffect(() => {
    CheckState();
  }, [state]);

  const GetAccountingSessions = async (inputValue) => {
    let accountingSessionReqs = new SearchAccountingSessions();

    accountingSessionReqs.id = inputValue;

    let res = await SessionsApi.SearchAccountingSessions(accountingSessionReqs);

    if (res.status === "Success") {
      return res.data.list.map((item) => ({
        value: item,
        label: "ID: " + item.id,
      }));
    }

    return [];
    y;
  };

  const GetPackages = async () => {
    let searchPackagesReq = new SearchPackagesReq();

    searchPackagesReq.packageName = PackagesSearch;

    let res = await SessionsApi.SearchPackages(searchPackagesReq);

    if (res.status == "Success") {
      let optionsArr = [];
      res.data.list.forEach((item) => {
        optionsArr.push({
          value: item,
          label: "ID: " + item.id + "Package Name: " + item.packageName,
        });
      });

      return optionsArr;
    }
  };

  useEffect(() => {
    if (entryType == EntryTypes.Salary && Object.keys(User).length > 0) {
      SetAmount(User.salary);
    }
  }, [User]);

  const GetUsers = async () => {
    let usersReq = new SearchUserModel();
    usersReq.name = UsersSearch;

    let res = await UsersApi.SearchUsers(usersReq);

    if (res.status == "Success") {
      let optionsArr = [];
      res.data.list.forEach((item) => {
        optionsArr.push({ value: item, label: item.name + ",  ID: " + item.id });
      });

      return optionsArr;
    }
  };

  const GetTherapists = async () => {
    let usersReq = new SearchUserModel();
    usersReq.userType = "Therapist";
    usersReq.name = TherapistsSearch;

    let res = await UsersApi.SearchUsers(usersReq);

    if (res.status == "Success") {
      let optionsArr = [];
      res.data.list.forEach((item) => {
        optionsArr.push({ value: item.therapistId, label: item.name });
      });

      return optionsArr;
    }
  };

  const GetAccountingTherapistHours = async () => {
    let accountingTherapistHourReq = new SearchAccountingTherapistHourId();
    accountingTherapistHourReq.userType = AccountingTherapistHourSearch;

    let res = await AccountingApi.accountingTherapistHourId(accountingTherapistHourReq);

    if (res.status == "Success") {
      let optionsArr = [];
      res.data.list.forEach((item) => {
        optionsArr.push({ value: item.id, label: "ID: " + item.id });
      });

      return optionsArr;
    }
  };

  const ShowEntrySelect = () => {
    switch (entryType) {
      case EntryTypes.AccSession:
        return (
          <>
            <div className="col-md-4 mt-4">
              <AsyncSelect
                isClearable={true}
                placeholder={`Accounting Session Id -- Auto Selected: ${AccountingSessionSelectDefault}`}
                loadOptions={GetAccountingSessions}
                defaultOptions={OptionSession}
                onInputChange={(value) => value}
                onChange={(e) => SetaccountingSession(e ? e.value : "")}
              />
            </div>
          </>
        );

      case EntryTypes.Package:
        return (
          <>
            <div className="col-md-4 mt-4">
              {/* accountingSessionId */}

              <AsyncSelect
                isClearable={true}
                className="full-width"
                placeholder="Package Id"
                defaultValue={PackageSelectDefault}
                defaultOptions={OptionPackage}
                loadOptions={GetPackages}
                onInputChange={SetPackagesSearch}
                onChange={(e) => SetPackage(e ? e.value : "")}
              />
            </div>
          </>
        );

      case EntryTypes.BalanceEntry:
        return (
          <>
            <div className="col-md-4 mt-4">
              {/* accountingSessionId */}

              <AsyncSelect
                isClearable={true}
                placeholder="User Id"
                defaultValue={UserSelectDefault}
                defaultOptions={OptionUser}
                loadOptions={GetUsers}
                onInputChange={SetUsersSearch}
                onChange={(e) => SetUser(e ? e.value : "")}
              />
            </div>
          </>
        );

      case EntryTypes.Salary:
        return (
          <>
            <div className="col-md-4 mt-4">
              {/* accountingSessionId */}

              <AsyncSelect
                isClearable={true}
                placeholder="User Id"
                defaultValue={UserSelectDefault}
                defaultOptions={OptionUser}
                loadOptions={GetUsers}
                onInputChange={SetUsersSearch}
                onChange={(e) => SetUser({ ...(e ? e.value : "") })}
              />
            </div>
          </>
        );

      case EntryTypes.AccThHour:
        return (
          <>
            <div className="col-md-4 mt-4">
              {/* accountingTherapistHourId */}

              <AsyncSelect
                isClearable={true}
                placeholder={`Accounting Therapist Hour Id -- Auto Selected: ${AccountingThHourSelectDefault}`}
                defaultValue={AccountingThHourSelectDefault}
                defaultOptions={OptionTherapis}
                loadOptions={GetAccountingTherapistHours}
                onInputChange={SetAccountingTherapistHourSearch}
                onChange={(e) => SetaccountingTherapistHourId(e ? e.value : "")}
              />
            </div>
          </>
        );
      default:
        break;
    }
  };
  const handleChange = (event) => {
    setPaymentMethod(event.target.value);
  };

  async function submitForm() {
    // if (title === "") {

    //   Swal.fire({
    //     title: 'Error',
    //     text: translations.itleisrequired,
    //     icon: 'error',
    //     confirmButtonText: 'Ok'
    //   })
    //   return;
    // }

    if (!title) {
      Swal.fire({
        title: "Error",
        text: "Title is required",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }
    if (!paymentMethod) {
      Swal.fire({
        title: "Error",
        text: "Payment Method is required",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }
    if (!amount && !state.AccSession.finalPrice === 0) {
      Swal.fire({
        title: "Error",
        text: "Amount is required",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }
    if (!description) {
      Swal.fire({
        title: "Error",
        text: "Description is required",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }
    if (!category) {
      Swal.fire({
        title: "Error",
        text: "Category is required",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }
    if (!entryType) {
      Swal.fire({
        title: "Error",
        text: "Entry Type is required",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }

    let model = new CreateAccountingEntryReq();

    model.title = title;
    model.accountingSessionId = accountingSession && accountingSession.id;
    model.accountingTherapistHourId = accountingTherapistHourId;
    model.userId = User && User.id;
    model.creatorId = CurrentUser.id;
    model.packageId = Package && Package.id;
    model.amount = amount;
    model.category = category;
    model.description = description;
    model.entryType = entryType;
    model.therapistId = therapistId;
    model.paymentMethod = paymentMethod;
    model.beneficiaryEntity = beneficiaryEntity;

    console.log(model);
    let res = await AccountingApi.CreateAccountingEntry(model);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: "Accounting Entry Created Successfully",
        icon: "success",
        confirmButtonText: "Ok",
      });
    } else {
      Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  }

  async function Refund() {
    let req = new RefundReq();
    req.accountingEntryId = accountingSession.getAccountingEntry.id;
    req.refundType = entryType;
    req.creatorId = CurrentUser.id;
    let res = await AccountingApi.Refund(req);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: "Refund Created Successfully",
        icon: "success",
        confirmButtonText: "Ok",
      });
    } else {
      Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  }

  useEffect(() => {
    if (entryType === EntryTypes.Expense && !EXPENSE_CATEGORIES.includes(category))
      SetCategory(EXPENSE_CATEGORIES[0]);
  }, [entryType]);

  if (!IsLoaded) {
    return <div>LOADING...</div>;
  }
  return (
    <>
      <MDBox mt={6} mb={3}>
        <div className="card">
          <div className={translations.setlang === "ar" ? "rtl-label" : ""}>
            <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
              <MDTypography variant="h6" fontWeight="medium">
                {translations.CreateAccountingEntrypg}
              </MDTypography>
              <MDButton
                onClick={() => submitForm()}
                sx={{ backgroundColor: "#3560AD", "&:hover": { backgroundColor: "#4682B4" } }}
                color="success"
              >
                &nbsp;{translations.createmultiPackageCreate}
              </MDButton>
            </MDBox>
            <div className="container-fluid mt-3">
              <div className="row">
                {/* title */}
                <div className="col-md-4 mt-2">
                  <MDInput
                    value={title}
                    className="full-width"
                    label={translations.CreateAccountingEntrypgtitle}
                    onChange={(e) => SetTitle(e.target.value)}
                    fullWidth
                  />
                </div>

                {/* amount */}
                <div className="col-md-4 mt-2">
                  <MDInput
                    value={amount}
                    className="full-width"
                    type="number"
                    onChange={(e) => SetAmount(e.target.value)}
                    label={translations.CreateAccountingEntrypgAmount}
                    fullWidth
                  ></MDInput>
                  <span className="text-success">{amount && "Selected Amount: EGP" + amount}</span>
                </div>
                <div className="col-md-4 mt-2">
                  {entryType === EntryTypes.Expense ? (
                    <select
                      className="full-width"
                      onChange={(e) => SetCategory(e.target.value)}
                      value={category}
                      style={{
                        direction: translations.setlang === "ar" ? "rtl" : "ltr",
                        textAlign: translations.setlang === "ar" ? "right" : "left",
                        width: "100%",
                      }}
                    >
                      {EXPENSE_CATEGORIES.map((c) => (
                        <option key={c} value={c}>
                          {c}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <MDInput
                      value={category}
                      className="full-width"
                      label={translations.SearchEnterycategory}
                      onChange={(e) => SetCategory(e.target.value)}
                      fullWidth
                    />
                  )}
                </div>

                <div className="col-md-4 mt-4">
                  <select
                    className="full-width"
                    onChange={(e) => SetEntryType(e.target.value)}
                    value={entryType}
                    style={{
                      direction: translations.setlang === "ar" ? "rtl" : "ltr",
                      textAlign: translations.setlang === "ar" ? "right" : "left",
                      width: "100%",
                    }}
                  >
                    {/* <option value={entryType} disabled>
                      {translations.CreateAccountingEntrypgSelectEntryType}:{" "}
                      {state ? state.entryType : ""}
                    </option> */}
                    {Object.keys(EntryTypes).map((t) => (
                      <option key={t} value={EntryTypes[t]}>
                        {EntryTypes[t]}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-4 mt-4">
                  <select
                    className="full-width"
                    labelId="payment-selector-label"
                    value={paymentMethod}
                    onChange={handleChange}
                    label="Payment Method"
                    style={{
                      direction: translations.setlang === "ar" ? "rtl" : "ltr",
                      textAlign: translations.setlang === "ar" ? "right" : "left",
                      width: "100%",
                    }}
                  >
                    <option value="" disabled selected>
                      {translations.SelectPaymentmethod}
                    </option>
                    <option value="Visa">{translations.SelectPaymentmethodvisa}</option>
                    <option value="Cash">{translations.SelectPaymentmethodCash}</option>
                    <option value="Bank-transfer">
                      {translations.SelectPaymentmethodBankTransfer}
                    </option>
                  </select>
                </div>

                <div className="col-md-4 mt-4">
                  <MDInput
                    value={beneficiaryEntity}
                    className="full-width"
                    label={translations.SearchEntrybeneficiary}
                    onChange={(e) => setBeneficiaryEntity(e.target.value)}
                    fullWidth
                  />
                </div>

                {ShowEntrySelect()}
                <div className="col-md-12 mt-4 ">
                  <textarea
                    type="text"
                    defaultValue={description}
                    className="form-control h-60"
                    placeholder={translations.CreateAccountingEntrypgdescription}
                    aria-describedby="sizing-addon1"
                    onChange={(e) => SetDescription(e.target.value)}
                  />
                </div>
              </div>
              {/* description */}
            </div>
          </div>
        </div>
      </MDBox>
    </>
  );
};
export default CreateAccountingEntry;
